<mat-card class="p-0 fx-flex-100 h-100">
  <div class="p-16">
    <span class="text bold">{{'CASE.INFORMATION' | translate}}</span>
  </div>
  <mat-divider></mat-divider>
  <div class="p-8 fx-row fx-wrap align-items-start justify-content-start" *ngIf="case && mode === 'CONSULTATION'">
    <div class="fx-flex-50 p-8 border-box fx-row align-items-center justify-content-start">
      <div class="fx-column">
        <span class="small light">{{'ENTITIES.TRADEMARK' | translate}}</span>
        <span class="text main">{{case.trademark.name || case.trademark.identifierNumber}}</span>
        <span class="small">{{case.trademark.countryOfDesignation}} - {{case.trademark.identifierNumber}}</span>
        <img [src]="trademark?.reproductionURI" class="reproduction mt-8" *ngIf="trademark?.reproductionURI" />
      </div>
    </div>

    <div class="fx-flex-50 p-8 border-box fx-column">
      <span class="small light">{{'CASE.NICE_CLASSIFICATION' | translate}}</span>
      <div class="fx-row fx-wrap align-items-center justify-content-start">
        <div class="fx-row fx-flex-100 align-items-center justify-content-start"
          *ngFor="let niceClass of case.niceClassification">
          <div class="chip main mt-5 mb-5" [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'NICE_CLASSES.'+niceClass |
              translate">
            {{'NICE_CLASSES.CLASS_NUMBER' | translate}}{{niceClass}}
          </div>
          <div class="chip outline ml-10"
            [class.clickable]="hasProductsServices() && getProductsServices(niceClass).length > 0"
            [class.red]="hasProductsServices() && getProductsServices(niceClass).length == 0"
            [class.main]="hasProductsServices() && getProductsServices(niceClass).length > 0" [cdkMenuTriggerFor]="menu"
            *ngIf="hasProductsServices() && getProductsServices(niceClass).length > 0">
            {{getProductsServices(niceClass).length}} {{((getProductsServices(niceClass).length > 1 ?
            'ENTITIES.PRODUCTS_SERVICES' :
            'ENTITIES.PRODUCT_SERVICE') | translate).toLowerCase()}}
          </div>
          <div class="chip red ml-10" *ngIf="hasProductsServices() && getProductsServices(niceClass).length == 0">
            {{getProductsServices(niceClass).length}} {{((getProductsServices(niceClass).length > 1 ?
            'ENTITIES.PRODUCTS_SERVICES' :
            'ENTITIES.PRODUCT_SERVICE') | translate).toLowerCase()}}
          </div>

          <div class="chip main outline ml-10 clickable" [cdkMenuTriggerFor]="menu" *ngIf="!hasProductsServices()">
            {{'CASE.ALL_PRODUCTS_SERVICES' | translate}}
          </div>
          <ng-template #menu>
            <mat-card class="menu-container p-8 elevation" cdkMenu>
              <div class="fx-row fx-wrap justify-content-start align-items-center">

                <span class="text dark fx-flex-100" *ngFor="let ps of getProductsServices(niceClass)"><span
                    class="text main mr-5">&bull;</span>{{ps}}</span>
              </div>
            </mat-card>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column" *ngIf="case.type">
      <span class="small light">{{'CASE.TYPE' | translate}}</span>
      <span class="text">{{'CASE.TYPE_'+case.type.toUpperCase() | translate}}</span>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <span class="small light">{{'ENTITIES.PROPERTY_OFFICE' | translate}}</span>
      <span class="text">{{propertyOffice?.name}}</span>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <span class="small light">{{'CASE.PERIOD' | translate}}</span>
      <span class="text">{{formatDate(case.timePeriod.start)}} - {{formatDate(case.timePeriod.end)}}</span>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <span class="small light">{{'CASE.REFERENCE' | translate}}</span>
      <span class="text">{{case.identifier || case.reference}}</span>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column" *ngIf="case.lang">
      <span class="small light">{{'CASE.LANG' | translate}}</span>
      <span class="text">{{'LANGUAGES.'+case.lang | translate}}</span>
    </div>
  </div>
  <div class="p-8 fx-row fx-wrap align-items-start justify-content-start" *ngIf="case && mode === 'EDITION'">
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-trademark-select [labelOutside]="true" label="{{'ENTITIES.TRADEMARK' | translate}}" [multiple]="false"
        [search]="true" initial="none" (change)="onTrademarkChange($event)" [(value)]="trademark" [emitOnInit]="true"
        class="fx-flex-100" [error]="validate('trademark')"></app-trademark-select>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-nice-select #niceSelect [labelOutside]="true" label="{{'ENTITIES.NICE_CLASSIFICATION' | translate}}"
        [multiple]="true" [search]="false" initial="none" (change)="onNiceClassificationChange($event)"
        [(value)]="niceClassification" [emitOnInit]="false" class="fx-flex-100" [restrict]="classesRestrictions()"
        [error]="validate('niceClassification')"></app-nice-select>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-select #caseTypeSelect initial="none" label="{{'CASE.TYPE' | translate}}" [options]="caseTypes"
        [multiple]="false" (change)="onCaseTypeChange($event)" [emitOnInit]="false" [(value)]="type"
        [labelOutside]="true" class="fx-flex-100" [error]="validate('type')"></app-select>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-product-service-select label="{{'ENTITIES.PRODUCTS_SERVICES' | translate}}" [multiple]="true" [search]="true"
        class="fx-flex-100 mb-5" [(value)]="productsServices" (change)="onProductServiceChange($event)"
        [emitOnInit]="false" [trademarks]="trademark ? [trademark] : []" [niceClassification]="niceClassification"
        [labelOutside]="true" [editTmNice]="false" [initial]="'all'" *ngIf="trademark">
      </app-product-service-select>
      <span class="small light">{{'CASE_DECLARE.SELECT_PRODUCTS_SERVICES_HINT' | translate}}</span>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-property-office-select [labelOutside]="true" label="{{'ENTITIES.PROPERTY_OFFICE' | translate}}"
        class="fx-flex-100" [search]="true" (change)="onPropertyOfficeChange($event)" [(value)]="propertyOffice"
        [error]="validate('propertyOffice')"></app-property-office-select>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-daterangepicker label="{{'ENTITIES.PERIOD' | translate}}" placeholder="{{'ENTITIES.PERIOD' | translate}}"
        [(value)]="period" class="fx-flex-100" (change)="onPeriodChange($event)"
        [error]="validate('period')"></app-daterangepicker>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-select initial="none" label="{{'CASE.LANG' | translate}}" [options]="langs" [multiple]="false"
        (change)="onLangChange($event)" [emitOnInit]="false" [value]="lang" [labelOutside]="true" class="fx-flex-100"
        [error]="validate('lang')"></app-select>
    </div>
    <div class="fx-flex-50 p-8 border-box fx-column">
      <app-input label="{{'CASE.REFERENCE' | translate}}" placeholder="{{'CASE.REFERENCE' | translate}}..."
        class="fx-flex-100" type="text" [(value)]="case.identifier"></app-input>
    </div>
  </div>
</mat-card>